import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from "i18next-http-backend";
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

i18n
  .use(Backend)
  .use(HttpApi) // Registering the back-end plugin
  // detect user language
  .use(LanguageDetector)

  .use(initReactI18next)

  .init({
    lng:cookies.get('i18nextLng'),
    fallbackLng: 'en',
    // debug: true,
    cache: ['cookie'],
    detection : {order: ['cookie','sessionStorage']},
    backend : {
        loadPath: '/locales/{{lng}}/translation.json',
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    }
  });


export default i18n;